module.exports = __webpack_public_path__ + "img/status_icon.10cedd69.png";